import React from "react";
import { Route, Routes } from "react-router-dom";

export interface RouteItem {
  path: string;
  name: string;
  main: () => JSX.Element;
}

/**
 *
 * @returns
 */
export interface RoutesGeneratorProps {
  basePath?: string;
  routesList?: RouteItem[];
}

/**
 * Routes Generator
 * @param param0 
 * @returns 
 */
export default function RoutesGenerator({
  basePath,
  routesList,
}: RoutesGeneratorProps) {
  if (!routesList) {
    return <></>;
  }
  return (
    <>
      <Routes>
        {routesList.map((route, index) => {
          return (
            <Route
              key={index}
              path={basePath !== undefined ? basePath + route.path : route.path}
              element={<route.main />}
            />
          );
        })}
      </Routes>
    </>
  );
}
